import { createContext, useContext } from 'react';
import { useAdminAnalyticsHierarchy } from '../hooks/useAdminAnalyticsHierarchy';

const AdminAnalyticsHierarchyContext = createContext(null);

export function AdminAnalyticsHierarchyProvider({ enabled, children }) {
  const hierarchy = useAdminAnalyticsHierarchy({ enabled });
  return (
    <AdminAnalyticsHierarchyContext.Provider value={enabled ? hierarchy : null}>
      {children}
    </AdminAnalyticsHierarchyContext.Provider>
  );
}

export function useAdminAnalyticsHierarchyContext() {
  const value = useContext(AdminAnalyticsHierarchyContext);
  if (!value) {
    throw new Error('useAdminAnalyticsHierarchyContext must be used on the admin analytics page');
  }
  return value;
}

export function useOptionalAdminAnalyticsHierarchy() {
  return useContext(AdminAnalyticsHierarchyContext);
}
